import React from "react";
import imageOne from "../../resource/meditate/external-retreat/rules and regulations/1.png";
import imageThree from "../../resource/meditate/external-retreat/rules and regulations/2.png";
import imageFour from "../../resource/dana/gilanpasa/gilanpasa-afternoon/photo.jpeg";

const InternalRules = () => {
  return (
    <div className="retreat-rules-page externalRules-page inside-pages dark-gold">
      {/* Top Right Image */}
      <div className="right-box">
        <img
          src={imageOne}
          alt="Top Decorative Image"
          className="right-image"
          width={300}
        />
      </div>

      {/* Page Title */}
      <h1 className="mt-4 dark-gold font-main p-4">Rules and Regulations</h1>
      <h2 className="mt-4 dark-gold font-second p-4">Internal Retreats</h2>

      {/* Introduction */}
      <div className="p-4 mt-5">
        <p className="h4 mt-5">
          The Bhaddeka Vihari Monastery and Meditation Centre was established to
          offer a deep understanding of the Dhamma, as taught by the Lord
          Buddha, and encourages individuals to reflect on these teachings in
          their daily lives. One of the primary services it offers is internal
          residential retreats. Notifications for these retreats are sent via
          social media, e-mail, and WhatsApp as well as on the Bhaddeka Vihari
          Monastery and Meditation Centre website. The Centre can accommodate up
          to 55 participants at a time, with retreat durations ranging from 1 to
          10 days.
        </p>
      </div>

      {/* Monastery Guidelines */}
      <h2 className="mt-6 dark-gold font-second p-4">Monastery Guidelines</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          All retreatants must adhere to the following guidelines while staying
          at the Bhaddeka Vihari Monastery and Meditation Centre:
        </p>

        <p className="h4 mt-5 ">1. Maintain noble silence.</p>
        <p className="h4 mt-5 ">2. Smoking is strictly prohibited.</p>
        <p className="h4 mt-5 ">
          3. The use of alcohol, tobacco, or any recreational drugs is
          forbidden.
        </p>
        <p className="h4 mt-5 ">
          4. Dress modestly while on the premises. Short trousers, singlets, and
          revealing clothing are not permitted.
        </p>
        <p className="h4 mt-5 ">
          5. Wear white clothing to maintain the tranquility of the premises.
        </p>
        <p className="h4 mt-5 ">
          6. Maintain a calm environment for yourself and others by switching
          off your mobile phones.
        </p>
        <p className="h4 mt-5 ">
          7. Refrain from discussing personal matters or Dhamma teachings among
          yourselves, and avoid giving Dhamma instructions to others.
        </p>
        <p className="h4 mt-5 ">
          8. Morning Dana, lunch Dana and afternoon Gilanpasa will be provided
          by the Retreat Centre.
        </p>
        <p className="h4 mt-5 ">
          9. Kindly ensure that your room is securely locked at all times while
          you are attending the retreat.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">Retreat Guidelines</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          Retreatants are required to read and agree to the following guidelines
          before booking a place in an internal retreat:
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">
            Non-refundable Application Fee:
          </span>{" "}
          A non-refundable application fee is required to minimize unnecessary
          applications and to help facilitate the retreat process.
        </p>

        <p className="h4 mt-5 ">
          1. All applications must be completed and submitted online.
        </p>
        <p className="h4 mt-5 ">
          2. Applications should be submitted at least one week before the
          retreat start date.
        </p>
        <p className="h4 mt-5 ">3. Applicants are selected based on:</p>
        <ul className="list-0 h4">
          <li>
            The suitability of the applicant through the Centre's standard
            review system.
          </li>
          <li>Availability of accommodation.</li>
        </ul>
        <p className="h4 mt-5 ">
          4. Applicants must receive written confirmation from the Retreat
          Centre before arriving.
        </p>
        <p className="h4 mt-5 ">
          5. The main applicant must be at least 18 years old. If an underage
          participant accompanies the main applicant, a separate application
          must be submitted (refer to “Stay with Children”).
        </p>
        <p className="h4 mt-5 ">
          6. Applicants must observe the Eight Precepts or higher (see “Eight
          Precepts” section).
        </p>
        <p className="h4 mt-5 ">
          7. Applicants should be in good physical and mental health.
        </p>
        <p className="h4 mt-5 ">
          8. Applicants must agree to follow the Retreat Centre timetable.
        </p>
        <p className="h4 mt-5 ">
          9. Applicants must inform the Monastery office each time they leave
          the Retreat Centre, including for short trips.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">Special Circumstances</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          No dinner will be provided during the retreat period. Retreatants who
          require dinner for medical reasons are kindly requested to make
          private arrangements for their meals. These privately arranged meals
          should be consumed in a manner that does not disturb or interfere with
          other retreatants.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">Dhamma Hall Guidelines</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          The Bhaddeka Vihari Monastery and Meditation Centre is proud to offer
          the Dhamma Hall for practice. Retreatants are encouraged to use this
          shared space mindfully, both for their own benefit and for that of
          others. The following guidelines must be observed while in the Dhamma
          Hall:
        </p>

        <p className="h4 mt-5 ">
          1. Handle all doors gently, avoiding unnecessary noise.
        </p>
        <p className="h4 mt-5 ">2. Phone usage is strictly prohibited.</p>
        <p className="h4 mt-5 ">
          3. Providing Dhamma discussions or meditation instructions to fellow
          retreatants is not allowed.
        </p>
        <p className="h4 mt-5 ">
          4. Minimize noise (e.g., plastic bottle sounds, zip bags, etc.).
        </p>
        <p className="h4 mt-5 ">
          5. Reading a book is not permitted unless advised by the Teacher.
        </p>
        <p className="h4 mt-5 ">
          6. Do not adjust lights or air conditioning settings while meditating.
          If adjustments are necessary, change the settings before starting the
          retreat or inform the Retreat Centre office.
        </p>
        <p className="h4 mt-5 ">
          7. At the end of the retreat, the Dhamma Hall and surrounding verandah
          must be cleaned and vacuumed.
        </p>
        <p className="h4 mt-5 ">
          8. All cushions must be returned to the storeroom.
        </p>

        <p className="h4 mt-5 ">
          If circumstances prevent fulfilling these tasks, notify the Retreat
          Centre officials to discuss the matter.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">
        Sickness and Emergencies
      </h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          In case of illness, the Retreat Centre will provide preliminary care
          for retreatants. If the condition persists, emergency contacts will be
          notified.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">Donations</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          There is no charge for teachings or accommodation at the Bhaddeka
          Vihari Retreat Centre, but donations are welcome. These donations help
          maintain the facilities and support the running of the Centre.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">Departure Guidelines</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          Before leaving the Retreat Centre, all retreatants should ensure the
          following tasks are completed:
        </p>

        <p className="h4 mt-5 ">
          1. Remove all personal belongings from the room and the bathroom.
        </p>
        <p className="h4 mt-5 ">
          2. Clean and vacuum the room, including wet areas such as the shower,
          toilet, and bathroom.
        </p>
        <p className="h4 mt-5 ">
          3. If using Retreat Centre bed linen (for interstate or overseas
          visitors), wash, dry, and return it to the Retreat Centre office. If
          unable to do this in time, hand it over to another laity or inform the
          office.
        </p>
        <p className="h4 mt-5 ">
          4. Switch off room lights and air conditioning equipment.
        </p>
        <p className="h4 mt-5 ">
          5. Report any damages or worn-out items to the Retreat Centre office.
        </p>
        <p className="h4 mt-5 ">
          6. Inform the Retreat Centre office of your departure.
        </p>
        <p className="h4 mt-5 ">
          7. Return the electronic key card with the door key to the Retreat
          Centre office if you stayed in a single room.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">Stay With Children</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">
          Children over the age of 10 are allowed to stay at the Retreat Centre
          under the following conditions:
        </p>

        <p className="h4 mt-5 ">
          1. Children must be accompanied by an adult who will act as their
          guardian during the stay.
        </p>
        <p className="h4 mt-5 ">
          2. Children must remain in the same room overnight with the
          accompanying adult, who must be of the same gender as the children.
        </p>
        <p className="h4 mt-5 ">
          3. The adult guardian must be well-known to the children and must have
          the consent of the children's parents.
        </p>
        <p className="h4 mt-5 ">
          4. The adult guardian is responsible for the children's behavior and
          must remain near them at all times.
        </p>
      </div>

      <h2 className="mt-6 dark-gold font-second p-4">Eight Precepts</h2>
      <div className="p-4">
        <p className="h4 mt-5 ">The Eight Precepts for Retreatants</p>

        <p className="h4 mt-5 ">
          1. I vow to refrain from killing any living being.
        </p>
        <p className="h4 mt-5 ">
          2. I vow to refrain from taking what has not been freely given.
        </p>
        <p className="h4 mt-5 ">
          3. I vow to refrain from any form of sexual activity.
        </p>
        <p className="h4 mt-5 ">
          4. I vow to refrain from false or harmful speech.
        </p>
        <p className="h4 mt-5 ">
          5. I vow to refrain from using intoxicants.
        </p>
        <p className="h4 mt-5 ">
          6. I vow to refrain from eating after midday.
        </p><p className="h4 mt-5 ">
          7. I vow to refrain from dancing, singing, playing music, engaging in entertainment, or using beautifying items such as jewelry, perfume, makeup, etc.
        </p><p className="h4 mt-5 ">
          8. I vow to refrain from indulging in high or luxurious seating or bedding.
        </p>
      </div>

      {/* Bottom Image */}
      <div className="bottom-box mt-6">
        <img src={imageThree} alt="Bottom Decorative Image" width={400} />
      </div>
    </div>
  );
};

export default InternalRules;
